import { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { PlayerProvider } from "./context/PlayerContext";
import { Layout, ProtectedRoute } from "./components/Layout";
import AgeGate from "./components/AgeGate";
import Discover from "./pages/Discover";
import StoryDetail from "./pages/StoryDetail";
import Auth from "./pages/Auth";
import Wallet from "./pages/Wallet";
import PaymentSuccess from "./pages/PaymentSuccess";
import Library from "./pages/Library";
import Notifications from "./pages/Notifications";
import CreatorDashboard from "./pages/CreatorDashboard";
import Moderation from "./pages/Moderation";
import Admin from "./pages/Admin";

function App() {
  const [ageOk, setAgeOk] = useState(() => localStorage.getItem("age_ok") === "1");

  const confirmAge = () => {
    localStorage.setItem("age_ok", "1");
    setAgeOk(true);
  };

  return (
    <AuthProvider>
      <PlayerProvider>
        <BrowserRouter>
          {!ageOk ? (
            <AgeGate onConfirm={confirmAge} />
          ) : (
            <Layout>
              <Routes>
                <Route path="/" element={<Discover />} />
                <Route path="/story/:id" element={<StoryDetail />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
                <Route path="/wallet" element={<ProtectedRoute><Wallet /></ProtectedRoute>} />
                <Route path="/library" element={<ProtectedRoute><Library /></ProtectedRoute>} />
                <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
                <Route path="/creator" element={<ProtectedRoute roles={["CREATOR", "ADMIN"]}><CreatorDashboard /></ProtectedRoute>} />
                <Route path="/moderation" element={<ProtectedRoute roles={["MODERATOR", "ADMIN"]}><Moderation /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute roles={["ADMIN"]}><Admin /></ProtectedRoute>} />
              </Routes>
            </Layout>
          )}
          <Toaster theme="dark" position="top-center" richColors />
        </BrowserRouter>
      </PlayerProvider>
    </AuthProvider>
  );
}

export default App;
